// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1PqMF","calendarButtons":"ClockData_calendarButtons__3l0ga"};